// The Comic Machine - Layer ListItem

var LayerListItem = (function() {

  // Get the template contents
  var template = (function() {
    var template = document.getElementById("template-layer");
    return template ? template.content.querySelector("li") : null;
  })();

  var loading = document.querySelector(".loading");

  // A layer list item instance for the LayerController
  function LayerListItem(options) {

    if (!template) {
      return;
    }

    var self = this;
    var layer = options.layer;
    var isBase = options.index === 0;
    var isSelected = options.index === options.selected;
    var isImage = layer.type === Layer.Types.IMAGE;
    var isText = layer.type === Layer.Types.TEXT;
    var hasContent = !!(layer.content || layer.edits.length > 0);
    var hasLayerEdits = layer.edits.length > 0;
    var hasOriginal = layer.original !== null;

    this.elements = {};
    this.template = template.cloneNode(true);
    this.layer = layer;
    this.index = options.index;
    this.label = isBase ? "Base" : "Layer " + this.index;
    this.name = layer.name ? layer.name : this.label;

    // Set attributes on list item
    this.template.className += isSelected ? " layer-selected" : "";
    this.template.className += options.selected !== 0 && !isSelected ? " layer-deselected" : "";
    this.template.setAttribute("data-index", this.index);
    this.template.setAttribute("data-uid", layer.uid);
    this.template.setAttribute("data-type", layer.type || "none");
    this.template.setAttribute("data-action", layer.action || "none");
    this.template.setAttribute("data-content", hasContent);

    this.elements.start = {
      position: {
        x: this.template.querySelector("input[name='layer-start-position-x']"),
        y: this.template.querySelector("input[name='layer-start-position-y']")
      },
      size: {
        width: this.template.querySelector("input[name='layer-start-size-width']"),
        height: this.template.querySelector("input[name='layer-start-size-height']")
      },
      scale: this.template.querySelector("input[name='layer-start-scale']"),
      opacity: this.template.querySelector("input[name='layer-start-opacity']"),
      set: this.template.querySelector("button[name='layer-start-set']")
    };
    this.elements.end = {
      position: {
        x: this.template.querySelector("input[name='layer-end-position-x']"),
        y: this.template.querySelector("input[name='layer-end-position-y']")
      },
      size: {
        width: this.template.querySelector("input[name='layer-end-size-width']"),
        height: this.template.querySelector("input[name='layer-end-size-height']")
      },
      scale: this.template.querySelector("input[name='layer-end-scale']"),
      opacity: this.template.querySelector("input[name='layer-end-opacity']"),
      set: this.template.querySelector("button[name='layer-end-set']")
    };

    // The preview thumbnail and name
    var preview = this.template.querySelector(".layer-preview");
    preview.setAttribute("data-index", this.index);
    if (this.layer.thumbnail) {
      preview.querySelector("img").src = layer.thumbnail;
    }
    preview.querySelector("span").title = this.name;
    preview.querySelector("span").innerHTML = this.name;
    // Bind the event handler
    attachHandler(preview, this.onThumbClick.bind(this));

    // The edit text button
    var editText = this.template.querySelector(".layer-edit-text");
    editText.style.display = isSelected && isText ? "block" : "none";
    // Bind the event handler
    attachHandler(editText, function() {
      TextController.initialize(layer.text, true);
    });

    // The layer type select
    var type = this.template.querySelector(".layer-type");
    type.setAttribute("data-index", this.index);
    type.appendChild(LayerListItem.renderLayerTypeOptions(this.layer));
    // Bind the event handler
    attachHandler(type, this.onTypeChange.bind(this), "change");
    // Remove the type select on the base layer
    isBase && this.template.removeChild(type);

    // The layer upload button
    var upload = this.template.querySelector(".layer-upload");
    upload.setAttribute("data-index", this.index);
    // Bind the event handler
    attachHandler(upload, this.onUploadClick.bind(this));
    // Remove the action select on the base layer
    isBase && this.template.removeChild(upload);

    // The layer move controls
    var moveDuration = this.template.querySelector("input[name='layer-move-duration']");
    moveDuration.value = this.layer.duration / 1000;
    // moveDuration.disabled = hasLayerEdits;

    var moveDelay = this.template.querySelector("input[name='layer-move-delay']");
    moveDelay.value = this.layer.delay / 1000;
    // moveDelay.disabled = hasLayerEdits;

    var moveRepeat = this.template.querySelector("input[name='layer-move-repeat']");
    moveRepeat.value = this.layer.loop;
    // moveRepeat.disabled = hasLayerEdits;

    var moveReverse = this.template.querySelector("input[name='layer-move-reverse']");
    moveReverse.checked = this.layer.reverse;
    // moveReverse.disabled = hasLayerEdits;

    // Render the transition panel
    this.renderTransitionOptions();

    // Render the layer scale options
    this.renderLayerScale();

    // Layer control menu
    var controlMenuItems = this.template.querySelectorAll(".layer-control-menu a");
    // Bind the event handler
    attachHandler(controlMenuItems, function(event) {
      var button = event.target;
      var current = button.getAttribute("data-panel");
      self.toggleTransitionFrame(current);
    });
    this.toggleTransitionFrame(layer.preview);

    // Easing options
    var easing = this.template.querySelector(".layer-easing");
    easing.value = layer.transition.easing;
    attachHandler(easing, function(event) {
      layer.transition.easing = easing.value;
    }, "change");

    // Add transition button
    var addTransition = this.template.querySelector(".button-edit");
    attachHandler(addTransition, function(event) {
      loading.querySelector(".loading-heading").innerHTML = "Adding...";
      loading.style.display = "none";
      loading.style.display = "block";
      loading.setAttribute("data-active", "true");
      var asset = JSON.parse(JSON.stringify(layer.asset));
      asset.layer = layer.original ? layer.original : layer.uid;
      layer.page.addLayerTransition(asset, function(result) {
        layer.page.selectLayer(layer.page.pageLayers.indexOf(result));
        // Update the UI
        Events.global.emit("tcm.layer.update");
        loading.setAttribute("data-active", "false");
      });
    });

    // Remove after settings
    var removeClicks = this.template.querySelector(".layer-remove-clicks");
    if (removeClicks) {
      attachHandler(removeClicks, function(event) {
        layer.removeAfter.duration = event.target.value;
      }, "change");
      if (layer.removeAfter && layer.removeAfter.duration) {
        removeClicks.value = layer.removeAfter.duration;
      }
      removeClicks.disabled = hasLayerEdits;
    }
    // var removeType = this.template.querySelector(".layer-remove-type");
    // var removeDuration = this.template.querySelector("input[name='layer-remove-duration']");
    // var removeDelay = this.template.querySelector("input[name='layer-remove-delay']");
    // if (removeType && removeDuration && removeDelay) {
    //    attachHandler(removeType, function(event) {
    //       layer.removeAfter.type = event.target.value;
    //       removeDuration.disabled = event.target.value === "none";
    //       removeDelay.disabled = event.target.value === "none";
    //    }, "change");
    //    removeType.value = layer.removeAfter.type;
    //    removeType.disabled = hasLayerEdits;
    // }
    //
    // if (removeType) {
    //    attachHandler(removeDuration, function(event) {
    //       layer.removeAfter.duration = event.target.value;
    //    }, "change");
    //    removeDuration.value = layer.removeAfter.duration;
    //    removeDuration.disabled = layer.removeAfter.type === "none" || hasLayerEdits;
    // }
    //
    // if (removeType) {
    //    attachHandler(removeDelay, function(event) {
    //       layer.removeAfter.delay = event.target.value;
    //    }, "change");
    //    removeDelay.value = layer.removeAfter.delay;
    //    removeDelay.disabled = layer.removeAfter.type === "none" || hasLayerEdits;
    // }

    // The wait action
    var wait = this.template.querySelector("input[name='layer-wait']");
    if (wait) {
      attachHandler(wait, function(event) {
        layer.transition.wait = event.target.checked;
      }, "change");
      wait.checked = layer.transition.wait;
    }

    // The layer remove button
    var remove = this.template.querySelector(".layer-remove");
    remove.setAttribute("data-index", this.index);
    // Bind the event handler
    attachHandler(remove, this.onRemoveClick.bind(this));
    // Remove the remove button on the base layer
    (isBase) && this.template.removeChild(remove); // hasLayerEdits

    // The layer controls
    var inputs = this.template.querySelectorAll(".layer-controls input");
    attachHandler(inputs, this.onControlInput.bind(this), "change");
    var buttons = this.template.querySelectorAll(".layer-controls button");
    attachHandler(buttons, this.onControlClick.bind(this));
    var checkboxes = this.template.querySelectorAll(".layer-controls input[type='checkbox']");
    attachHandler(checkboxes, this.onControlCheck.bind(this), "change");

    // Check for wait
    if (layer.transition && layer.transition.wait) {
      var waiting = '<span class="layer-waiting">WAIT</span>';
      this.template.querySelector(".layer-preview").innerHTML += waiting;
    }

  }

  // Method to render the layer scale options
  LayerListItem.prototype.renderLayerScale = function() {

    var layer = this.layer;
    var elements = this.elements;
    var width = layer.size.width;
    var ratio = layer.size.height / layer.size.width;

    function onScaleInput(event) {
      layer.scaleProportionally(this.value, {
        min: this.min,
        max: this.max,
        width: width,
        ratio: ratio
      });
    }

    function onScaleChange(event) {
      layer.scaleProportionally(this.value, {
        min: this.min,
        max: this.max,
        width: width,
        ratio: ratio
      });
      this.value = 0;
      width = layer.size.width;
    }

    elements.start.scale.addEventListener("change", onScaleChange);
    elements.start.scale.addEventListener("input", onScaleInput);
    elements.end.scale.addEventListener("change", onScaleChange);
    elements.end.scale.addEventListener("input", onScaleInput);

  }

  // Method to render the layer transition start / end options
  LayerListItem.prototype.renderTransitionOptions = function() {

    var layer = this.layer;
    var startSet = layer.transition.start.set;
    var endSet = layer.transition.end.set;

    var startInputX = new LayerInput({
      element: this.elements.start.position.x,
      object: layer.transition.start,
      property: "x",
      handler: function(value) {
        layer.position.x = value;
        Comic.renderPage();
      },
      callback: function(value) {
        Comic.renderPage();
      }
    });

    var startInputY = new LayerInput({
      element: this.elements.start.position.y,
      object: layer.transition.start,
      property: "y",
      handler: function(value) {
        layer.position.y = value;
        Comic.renderPage();
      },
      callback: function(value) {
        Comic.renderPage();
      }
    });

    var handleInputWidth = function(width) {
      var height = layer.size.height;
      if (width !== null && height !== null) {
        if (layer.proportionLock) {
          var ratio = width / layer.content.width;
          height = Math.floor(layer.content.height * ratio);
          layer.size.height = height;
          this.object.height = height;
        }
      }
    };
    var handleInputHeight = function(height) {
      var width = layer.size.width;
      if (width !== null && height !== null) {
        if (layer.proportionLock) {
          var ratio = height / layer.content.height;
          width = Math.floor(layer.content.width * ratio);
          layer.size.width = width;
          this.object.width = width;
        }
      }
    };

    var callbackInputWidth = function(width) {
      var height = layer.size.height;
      if (width !== null && height !== null) {
        layer.setSize(width, height, true);
      }
      Comic.renderPage();
    };
    var callbackInputHeight = function(height) {
      var width = layer.size.width;
      if (width !== null && height !== null) {
        layer.setSize(width, height, true);
      }
      Comic.renderPage();
    };

    var startInputWidth = new LayerInput({
      element: this.elements.start.size.width,
      object: layer.transition.start,
      property: "width",
      onInput: handleInputWidth,
      callback: callbackInputWidth
    });

    var startInputHeight = new LayerInput({
      element: this.elements.start.size.height,
      object: layer.transition.start,
      property: "height",
      onInput: handleInputHeight,
      callback: callbackInputHeight
    });

    var propLock = this.template.querySelectorAll("input[name='layer-proportional-lock']");
    // TODO: proportion lock for each state
    for (var i = 0, length = propLock.length; i < length; i++) {
      var prop = propLock[i];
      prop.checked = layer.proportionLock;
    }
    attachHandler(propLock, function(event) {
      layer.proportionLock = event.target.checked;
      for (var i = 0, length = propLock.length; i < length; i++) {
        propLock[i].checked = layer.proportionLock;
      }
    }, "change");

    var startInputOpacity = new LayerInput({
      element: this.elements.start.opacity,
      object: layer.transition.start,
      property: "opacity",
      callback: function(value) {
        Comic.renderPage();
      }
    });

    var endInputX = new LayerInput({
      element: this.elements.end.position.x,
      object: layer.transition.end,
      property: "x",
      callback: function(value) {
        Comic.renderPage();
      }
    });

    var endInputY = new LayerInput({
      element: this.elements.end.position.y,
      object: layer.transition.end,
      property: "y",
      callback: function(value) {
        Comic.renderPage();
      }
    });

    var endInputWidth = new LayerInput({
      element: this.elements.end.size.width,
      object: layer.transition.end,
      property: "width",
      onInput: handleInputWidth,
      callback: callbackInputWidth
    });

    var endInputHeight = new LayerInput({
      element: this.elements.end.size.height,
      object: layer.transition.end,
      property: "height",
      onInput: handleInputHeight,
      callback: callbackInputHeight
    });

    var endInputOpacity = new LayerInput({
      element: this.elements.end.opacity,
      object: layer.transition.end,
      property: "opacity",
      callback: function(value) {
        Comic.renderPage();
      }
    });

    this.toggleTransitionOptions();

    // Check for layer edit
    if (this.layer.original === null) {
      this.elements.start.set.setAttribute("data-set", startSet ? "true" : "false");
      this.elements.start.set.innerHTML = startSet ? "Unset" : "Set"; // HACK
      // this.elements.start.set.disabled = hasLayerEdits;
      // this.elements.start.set.setAttribute("data-disabled", hasLayerEdits ? "true" : "false");
    } else {
      this.elements.start.set.setAttribute("data-set", "true");
      this.elements.start.set.setAttribute("data-disabled", "true");
      this.elements.start.set.innerHTML = "Set"; // HACK
    }

    // Set transition end
    this.elements.end.set.setAttribute("data-set", endSet ? "true" : "false");
    this.elements.end.set.innerHTML = endSet ? "Unset" : "Set"; // HACK
    // this.elements.end.set.disabled = hasLayerEdits;
    // this.elements.end.set.setAttribute("data-disabled", hasLayerEdits ? "true" : "false");

  };

  // Method to disable/enable the layer transition start / end options
  LayerListItem.prototype.toggleTransitionOptions = function() {

    var layer = this.layer;
    var startSet = layer.transition.start.set;
    var endSet = layer.transition.end.set;
    var showEdit = startSet && endSet && layer.removeAfter.type === "none";
    var button = this.template.querySelector(".button-edit");

    this.elements.start.position.x.disabled = startSet;
    this.elements.start.position.y.disabled = startSet;
    this.elements.start.size.width.disabled = startSet;
    this.elements.start.size.height.disabled = startSet;
    this.elements.start.scale.disabled = startSet;
    this.elements.start.opacity.disabled = startSet;

    this.elements.end.position.x.disabled = endSet;
    this.elements.end.position.y.disabled = endSet;
    this.elements.end.size.width.disabled = endSet;
    this.elements.end.size.height.disabled = endSet;
    this.elements.end.scale.disabled = endSet;
    this.elements.end.opacity.disabled = endSet;

    button.setAttribute("data-enabled", showEdit ? "true" : "false");

    Comic.renderPage();

  };

  // Method to toggle the transition start / end
  LayerListItem.prototype.toggleTransitionFrame = function(current) {

    var layer = this.layer;
    var items = this.template.querySelectorAll(".layer-control-menu a");
    var panels = this.template.querySelectorAll(".layer-controls .form-panel");

    for (var i = 0, length = items.length; i < length; i++) {
      var item = items[i];
      var panel = item.getAttribute("data-panel");
      var active = panel === current;
      item.setAttribute("data-active", active);
    }

    for (var i = 0, length = panels.length; i < length; i++) {
      var item = panels[i];
      var panel = item.getAttribute("data-panel");
      var active = panel === current;
      item.setAttribute("data-active", active);
    }

    layer.preview = current;
    layer.setOffset({
      x: 0,
      y: 0
    });

    var transition = layer.transition[layer.preview];
    if (transition) {
      if (transition.x || transition.x === 0) layer.position.x = transition.x;
      if (transition.y || transition.y === 0) layer.position.y = transition.y;
      if (transition.width || transition.width === 0) layer.size.width = transition.width;
      if (transition.height || transition.height === 0) layer.size.height = transition.height;
      layer.setSize(layer.size.width, layer.size.height, true);
    }

    Comic.renderPage();

  };

  // Builds the HTML select options for the layer type
  LayerListItem.renderLayerTypeOptions = function(layer) {

    // The layer type select
    var list = document.createDocumentFragment();

    // Loop over layer types to build options
    for (var type in Layer.Types) {
      var option = document.createElement("option");
      option.value = type;
      option.innerHTML = type.toTitleCase();
      // Set the selected state
      option.selected = layer.type === Layer.Types[type];
      // Push to the list of options
      if (type === "IMAGE") {
        list.appendChild(option);
      }
    }

    return list;

  };

  // Builds the HTML select options for the layer action
  LayerListItem.renderLayerActionOptions = function(layer) {

    // The layer action select
    var list = document.createDocumentFragment();

    // Skip non-image layers
    if (layer.type !== Layer.Types.IMAGE) {
      return list;
    }

    var actions = {
      original: ["ADD", "MOVE"],
      edits: ["MOVE", "REMOVE"]
    };

    var options = layer.original ? actions.edits : actions.original;

    // Loop over layer actions to build options
    options.forEach(function(action) {
      var option = document.createElement("option");
      option.value = action;
      option.innerHTML = action.toTitleCase();
      // Set the selected state
      option.selected = layer.action === Layer.Actions[action];
      // Push to the list of options
      list.appendChild(option);
    });

    return list;

  };

  // Handle on click of the thumbnail
  LayerListItem.prototype.onThumbClick = function(event) {
    Page.selectLayer(this.index);
    document.querySelector(".layer-selected").scrollTop = 0;
  };

  // Handle on click of the remove layer button
  LayerListItem.prototype.onRemoveClick = function(event) {
    if (Page.currentPage().layerIndex === 0) {
      if (window.confirm("Are you sure you would like to delete this layer?")) { // HACK
        Page.removeLayer(this.index);
      }
    } else {
      Page.selectLayer(0);
    }
  };

  // Handle on click of the upload button
  LayerListItem.prototype.onUploadClick = function(event) {
    Events.global.emit("tcm.layer.upload");
  };

  // Handle on change of select layer type
  LayerListItem.prototype.onTypeChange = function(event) {

    var layer = Page.getLayerByIndex(this.index);

    layer.type = Layer.Types[event.target.value];
    Events.global.emit("tcm.layer.update");

  };

  // Handle on change of select layer action
  LayerListItem.prototype.onActionChange = function(event) {

    var layer = Page.getLayerByIndex(this.index);

    layer.action = Layer.Actions[event.target.value];

    if (layer.action === Layer.Actions.ADD) {
      layer.transition = {
        start: {
          opacity: 0
        },
        end: {
          opacity: 1
        }
      };
    } else if (layer.action === Layer.Actions.REMOVE) {
      layer.transition = {
        start: {
          opacity: 1
        },
        end: {
          opacity: 0
        }
      };
    }

    Events.global.emit("tcm.layer.update");

  };

  // Handle on input of layer controls
  LayerListItem.prototype.onControlInput = function(event) {

    var input = event.target;
    var number = window.parseFloat(input.value);

    // console.log(input.name, input.value, number);

    switch (input.name) {

      case "layer-start-position-x":
        if (number || number === 0) {
          if (this.layer.transition.start) {
            this.layer.transition.start.x = number;
          } else {
            this.layer.transition.start = {
              x: number
            };
          }
          // this.layer.position.x = number;
          Comic.renderPage();
        }
        break;

      case "layer-start-position-y":
        if (number || number === 0) {
          if (this.layer.transition.start) {
            this.layer.transition.start.y = number;
          } else {
            this.layer.transition.start = {
              y: number
            };
          }
          // this.layer.position.y = number;
          Comic.renderPage();
        }
        break;

      case "layer-end-position-x":
        if (number || number === 0) {
          if (this.layer.transition.end) {
            this.layer.transition.end.x = number;
          } else {
            this.layer.transition.end = {
              x: number
            };
          }
          // this.layer.position.x = number;
          Comic.renderPage();
        }
        break;

      case "layer-end-position-y":
        if (number || number === 0) {
          if (this.layer.transition.end) {
            this.layer.transition.end.y = number;
          } else {
            this.layer.transition.end = {
              y: number
            };
          }
          // this.layer.position.y = number;
          Comic.renderPage();

        }
        break;

        // case "layer-add-duration":
      case "layer-move-duration":
        // case "layer-remove-duration":
        if (number || number === 0) {
          var min = window.parseInt(input.min, 10);
          var max = window.parseInt(input.max, 10);
          var value = Math.clamp(number, min, max);
          this.layer.duration = value * 1000;
        }
        break;

        // case "layer-add-delay":
      case "layer-move-delay":
        // case "layer-remove-delay":
        if (number || number === 0) {
          var min = window.parseInt(input.min, 10);
          var max = window.parseInt(input.max, 10);
          var value = Math.clamp(number, min, max);
          this.layer.delay = value * 1000;
        }
        break;

      case "layer-move-repeat":
        if (number || number === 0) {
          var min = window.parseInt(input.min, 10);
          var max = window.parseInt(input.max, 10);
          var value = Math.clamp(number, min, max);
          this.layer.loop = value;
        }
        break;

    }

  };

  // Handle on check of layer controls
  LayerListItem.prototype.onControlCheck = function(event) {

    var input = event.target;

    switch (input.name) {

      case "layer-move-reverse":
        this.layer.reverse = input.checked;
        break;

    }

  };

  // Handle on click of layer controls
  LayerListItem.prototype.onControlClick = function(event) {

    var button = event.target;
    var transition = this.layer.transition;
    var edit = false;

    switch (button.name) {
      case "layer-start-set":
        transition.start.set = !transition.start.set;
        button.innerHTML = transition.start.set ? "Unset" : "Set"; // HACK
        button.setAttribute("data-set", transition.start.set ? "true" : "false");
        edit = true;
        break;
      case "layer-end-set":
        transition.end.set = !transition.end.set;
        button.innerHTML = transition.end.set ? "Unset" : "Set"; // HACK
        button.setAttribute("data-set", transition.end.set ? "true" : "false");
        edit = true;
        break;
      case "layer-start-position-copy":
        transition.start.x = transition.end.x;
        transition.start.y = transition.end.y;
        break;
      case "layer-start-size-copy":
        transition.start.width = transition.end.width;
        transition.start.height = transition.end.height;
        break;
      case "layer-end-position-copy":
        transition.end.x = transition.start.x;
        transition.end.y = transition.start.y;
        break;
      case "layer-end-size-copy":
        transition.end.width = transition.start.width;
        transition.end.height = transition.start.height;
        break;
      default:
        edit = null;
        break;
    }

    if (edit !== null) {
      this.toggleTransitionOptions();
    }
  };

  // Public / exposed class
  return LayerListItem;

})();
